module.exports = __webpack_public_path__ + "static/media/tv.457dee12.jpg";